<div class="sm-context-menu" [class.sm-context-menu--stretch]="menuWidth === 'stretch'">
    <button
      #triggerButton
      class="sm-context-menu__trigger"
      [class.sm-context-menu__trigger--ellipsis]="triggerVariant === 'ellipsis'"
      type="button"
      [attr.aria-label]="triggerAriaLabel || null"
      [smPlainTextTooltip]="triggerTooltip"
      [smPlainTextTooltipAnchor]="triggerTooltipAnchor"
      [smPlainTextTooltipBlurOnEscape]="triggerTooltipBlurOnEscape"
      [smPlainTextTooltipDisabled]="isOpen"
      [attr.aria-expanded]="isOpen"
      aria-haspopup="menu"
      (click)="toggle()">
    <ng-content select="[smContextMenuTrigger]"></ng-content>
  </button>

  @if (isOpen) {
    <div class="sm-context-menu__backdrop" aria-hidden="true" (click)="close()"></div>

    <div
      #panel
      class="sm-context-menu__panel"
      [class.sm-context-menu__panel--ready]="panelReady"
      [style.top.px]="panelReady ? panelTop : -9999"
      [style.left.px]="panelReady ? panelLeft : -9999"
      [style.width.px]="panelWidth"
      role="menu">
      @for (item of items; track trackById($index, item)) {
        <sm-context-menu-item
          [item]="item"
          [selectionStyle]="selectionStyle"
          (itemClick)="selectItem($event)">
        </sm-context-menu-item>
      }
    </div>
  }
</div>
